/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GameControllerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABiUlEQVR4nOVVS0oDQRANbv0u9SqiuIoGneqqWXSqwggewV3Ab9zlCLoRbxAXOUBuIFl4AyNx5UIXCoGMdEw6ncyM6ZCAoAUFTffr9+rTn1zuT1kYRhuAUgbiGiA/KZIuIN9qrVfHsYhHa4rkzmAUSet7j5QNR6aAQmkqkjjFO4r4ddTNXBILxA/p5KEc9KOJZ/QuYnEvURpF8jkH8rjnyB/7Wq870RcjF4DImwGVtnwJgeQknz9cBORTOx8WIysAKFV3gxUmPwGt9VIPr9SyFUWpus2tDyIf703gkYmJ3Igo4rNhmaSeOD2GLHkcedu7LCN9kOZQgPhl2hLplLKMCbTdHry7iyaTrMjVT2UZzfDNySD90szoHVdg3uSxW+rfFuDHgHgXiFERHxs3YzNn1mYWCKi0k3i4PO/IRAEgaWSR2xNI0pgoAMTP00Y/MIPJEGhZECBfJaPnmgVMMEV8n9K7SwuoVCoLgHzR+8VQ2oB8bW6or0ChEK0A8Y15Efo/4bnh9N2f+9/2BWKtemQsiI0zAAAAAElFTkSuQmCC)
 */
export const GameControllerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M20.97 4.06c0 .18.08.35.24.43.55.28.9.82 1.04 1.42.3 1.24.75 3.7.75 7.09v4.91a3.09 3.09 0 0 1-5.85 1.38l-1.76-3.51a1.09 1.09 0 0 0-1.23-.55c-.57.13-1.36.27-2.16.27s-1.6-.14-2.16-.27c-.49-.11-1 .1-1.23.55l-1.76 3.51A3.09 3.09 0 0 1 1 17.91V13c0-3.38.46-5.85.75-7.1.15-.6.49-1.13 1.04-1.4a.47.47 0 0 0 .24-.44c0-.7.48-1.32 1.2-1.47l2.93-.62c.5-.1 1 .06 1.36.4.35.34.78.71 1.28.68a42.4 42.4 0 0 1 4.4 0c.5.03.93-.34 1.28-.69.35-.33.86-.5 1.36-.39l2.94.62c.7.15 1.19.78 1.19 1.47ZM20 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 7a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2H7v1a1 1 0 1 1-2 0v-1H4a1 1 0 1 1 0-2h1V7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
